import { render, staticRenderFns } from "./EditSelected.vue?vue&type=template&id=36a92efc"
import script from "./EditSelected.vue?vue&type=script&lang=js"
export * from "./EditSelected.vue?vue&type=script&lang=js"
import style0 from "./EditSelected.vue?vue&type=style&index=0&lang=postcss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports